import { SessionSiteSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import {IDataSourceDetailInfo} from '~src/datasource/models/IDataSourceInfo';
import { IDatasourceActions } from '~src/datasource/ServerApi/types/IDatasourceActions';
import { AskDataMode } from '~src/settings/types/AskDataMode';
import { createNewLens } from '~src/spacesPlatform/actions/ContentExplorerCreateActions';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleEmbeddedDatasource } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { SpaceInfoItemTypeValue } from '~src/spacesPlatform/models/ContentType';
import { ISpaceTypeInfo } from '~src/spacesPlatform/models/resourceInfoParts';
import { selectAvailableActionsForEntity } from '~src/spacesPlatform/selectors/EntityActionsSelectors';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { SiteRolesUtil } from '~src/userManagement/services/resources/SiteRolesUtil';

import { Messages } from '../../codegen/Localize';
import { IWebEditFlowAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { IsNlpEnabled } from '../utils/LensUtil';

export const NewLensEntityAction: IEntityAction<IContentInfo<'datasource'>, IWebEditFlowAction> = {
  name: EntityActionNames.NewLens,
  translateName: Messages.newLens,
  isVisible: (targetItems: IContentInfo[], appState: AppState) => {
    return IsNlpEnabled() && !isSingleEmbeddedDatasource(targetItems) &&
      SessionSiteSelectors.askDataMode(appState) === AskDataMode.DISABLED_BY_DEFAULT;
  },
  isClickable: (availableActions: IWebEditFlowAction, targetItems: IContentInfo[], appState: AppState) => {
    const spaceItem: ISpaceTypeInfo = selectSpaceInfoItem(appState);
    if (spaceItem && spaceItem.contentType === SpaceInfoItemTypeValue.datasource) {
      const availableActionsForEntity: IDatasourceActions | undefined = selectAvailableActionsForEntity(appState, { contentType: SpaceInfoItemTypeValue.datasource, id: spaceItem.id }) as IDatasourceActions;
      return !!availableActionsForEntity &&
        availableActionsForEntity.launchWebAuthoring &&
        SiteRolesUtil.canPublish(SessionSiteSelectors.siteRole(appState));
    }
    return SessionUserSelectors.canAuthorOnWeb(appState) && SiteRolesUtil.canPublish(SessionSiteSelectors.siteRole(appState));
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === SpaceInfoItemTypeValue.datasource) {
      const datasourceInfo = item as IDataSourceDetailInfo;
      if (datasourceInfo) {
        // After vizportalClient transits from idForFavoriting to id, we can always use datasourceInfo.id.
        // For now, in some code paths, datasourceInfo.idForFavoriting is the published datasource ID while
        // datasourceInfo.id isn't.
        const publishedDatasourceId = datasourceInfo.idForFavoriting || datasourceInfo.id;
        // datasourceLuid is only defined for data source returned from CRASS and that gets priority
        const datasourceLuid = datasourceInfo.datasourceLuid || datasourceInfo.luid;
        const projectId = datasourceInfo.project?.id;
        const datasourceName = datasourceInfo.name;
        const datasourceDescription = datasourceInfo.description;
        return createNewLens(projectId, parseInt(publishedDatasourceId), datasourceLuid, datasourceName, datasourceDescription);
      }

      return createNewLens();
    }
  }
};
